import Button from "@mui/material/Button"
import CssBaseline from "@mui/material/CssBaseline"
import TextField from "@mui/material/TextField"
import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import Container from "@mui/material/Container"
import { createTheme, ThemeProvider } from "@mui/material/styles"
import logo from "../assets/logo.svg"
import { useEffect, useState } from "react"
import { useAuthState } from "react-firebase-hooks/auth"
import { useNavigate } from "react-router-dom"

import {
	getMultiFactorResolver,
	signInWithEmailAndPassword,
	RecaptchaVerifier,
	/* signOut, */ PhoneAuthProvider,
	PhoneMultiFactorGenerator,
	browserSessionPersistence,
	setPersistence,
} from "firebase/auth"
import { auth } from "../util/firebase"

const theme = createTheme({
	palette: {
		primary: {
			main: "#132242",
		},
		secondary: {
			main: "#DF0A0A",
		},
	},
})

export default function SignIn() {
	const [user, loading] = useAuthState(auth)

	const [username, setUsername] = useState("")
	const [password, setPassword] = useState("")
	const [verificationId, setverificationId] = useState(null)
	const [verificationCode, setVerificationCode] = useState("")
	const [recaptchaVerifier, setRecaptchaVerifier] = useState(null)
	const [resolver, setResolver] = useState(null)
	const [loginError, setLoginError] = useState(null)
	const navigate = useNavigate()

	useEffect(() => {
		setRecaptchaVerifier(
			new RecaptchaVerifier(auth, "sign-in-button", {
				size: "invisible",
				callback: (response) => {},
			})
		)
	}, [])

	useEffect(() => {
		if (loading) {
			// maybe trigger a loading screen
			return
		}
		const getToken = async () => {
			const idTokenResult = await user.getIdTokenResult()
			if (idTokenResult.claims.admin) {
				navigate("/")
			}
		}
		if (user?.emailVerified) {
			getToken()
		}
		//if (user) console.log("MFA signed IN!")
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [loading, user])

	const handleSignIn = async () => {
		setLoginError(null)
		try {
			await setPersistence(auth, browserSessionPersistence)
			await signInWithEmailAndPassword(auth, username, password)
			//await signOut(auth)
			//setLoginError("משתמש אדמין לא מוגדר תקין")
		} catch (error) {
			if (error.code === "auth/multi-factor-auth-required") {
				// The user is a multi-factor user. Second factor challenge is required.
				const _resolver = getMultiFactorResolver(auth, error)
				setResolver(_resolver)
				const phoneInfoOptions = {
					multiFactorHint: _resolver.hints[0],
					session: _resolver.session,
				}
				console.log(`resolver = ${JSON.stringify(_resolver)}`)
				//const phoneAuthProvider = new PhoneAuthProvider(auth);
				const phoneAuthProvider = new PhoneAuthProvider(auth)
				const _verificationId = await phoneAuthProvider.verifyPhoneNumber(phoneInfoOptions, recaptchaVerifier)
				setverificationId(_verificationId)
			} /* if (error.code === "auth/wrong-password") */ else {
				setLoginError("משתמש אדמין לא מוגדר תקין")
			}
		}
	}

	const hadnleVerification = async () => {
		const cred = PhoneAuthProvider.credential(verificationId, verificationCode)
		const multiFactorAssertion = PhoneMultiFactorGenerator.assertion(cred)
		const userCredential = await resolver.resolveSignIn(multiFactorAssertion)
		console.log(userCredential)
		// Complete sign-in.
	}

	return (
		<ThemeProvider theme={theme}>
			<Container component="main" maxWidth="xs">
				<CssBaseline />
				<Box
					sx={{
						marginTop: 8,
						display: "flex",
						flexDirection: "column",
						alignItems: "center",
					}}
				>
					<img src={logo} style={{ width: "246px", height: "72px" }} alt="Logo" />
					<Typography component="h1" variant="h5">
						אדמין
					</Typography>
					<TextField
						margin="normal"
						required
						fullWidth
						id="email"
						label="שם משתמש"
						name="email"
						autoComplete="email"
						autoFocus
						onChange={(e) => setUsername(e.target.value)}
						value={username}
					/>
					<TextField
						margin="normal"
						required
						fullWidth
						name="password"
						label="סיסמה"
						type="password"
						id="password"
						autoComplete="current-password"
						onChange={(e) => setPassword(e.target.value)}
						value={password}
						onKeyDown={(e) => {
							if (e.code === "Enter" || e.code === "NumpadEnter") {
								handleSignIn()
							}
						}}
					/>
					{loginError && (
						<Typography component="h1" variant="body1" color={"red"}>
							{loginError}
						</Typography>
					)}
					{!verificationId && (
						<Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2 }} onClick={() => handleSignIn()}>
							היכנס
						</Button>
					)}
					{verificationId && (
						<>
							<TextField
								margin="normal"
								required
								fullWidth
								id="verificationCode"
								label="OTP"
								name="verificationCode"
								/* autoComplete="email" */
								autoFocus
								onChange={(e) => setVerificationCode(e.target.value)}
								value={verificationCode}
								onKeyDown={(e) => {
									if (e.code === "Enter" || e.code === "NumpadEnter") {
										hadnleVerification()
									}
								}}
							/>
							<Button
								type="submit"
								fullWidth
								variant="contained"
								sx={{ mt: 3, mb: 2 }}
								onClick={() => hadnleVerification()}
							>
								היכנס
							</Button>
						</>
					)}
					<div id={"sign-in-button"} />
					{/* <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            sx={{ mt: 3, mb: 2 }}
                            endIcon={<GoogleIcon />}
                            onClick={() => signInWithGoogle()}
                        >
                            היכנס עם Google
                        </Button>
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            sx={{ mt: 3, mb: 2 }}
                            endIcon={<FacebookIcon />}
                            onClick={() => signInWithFaceBook()}
                        >
                            היכנס עם Facebook
                        </Button> */}
				</Box>
			</Container>
		</ThemeProvider>
	)
}
